const initialState = {
  downpaymentRes: '',
};

function creditDownPayment(state = initialState, action) {
  switch (action.type) {
    case 'RUN_CREDIT_DOWNPAYMENT_SUCCESS_RESPONSE':
      return { ...state, downpaymentRes: action.response };
    default:
      return state;
  }
}


export default creditDownPayment;
